import type { DispatchRequestDto, DispatchStop } from './types';

export const formatDispatchTime = (time?: string | null) => (time ? time.slice(0, 5) : '—');

/** Just the fields any reader needs to render a request's pickup addresses. */
export type DispatchStopsSource = Pick<DispatchRequestDto, 'location' | 'stops'>;

/**
 * Complete pickup stops in visiting order. Legacy reads that only carry the
 * denormalized header location are represented as stop 1 so every disclosure
 * surface can share the same rendering contract.
 */
export const dispatchStops = (row: DispatchStopsSource): DispatchStop[] => {
  const fromStops = (row.stops ?? [])
    .filter((stop) => !!stop.location?.trim())
    .sort((left, right) => left.stop_seq - right.stop_seq);
  if (fromStops.length > 0) return fromStops;
  return row.location ? [{ stop_seq: 1, location: row.location, notes: null }] : [];
};

/**
 * Pickup addresses in visiting order. Reads that carry no stop list (legacy
 * cache, test fixtures) fall back to the denormalized header `location`, which
 * the backend keeps equal to stop 1.
 */
export const dispatchStopLocations = (row: DispatchStopsSource): string[] => {
  return dispatchStops(row).map((stop) => stop.location);
};

/** `title` body listing every stop; undefined below two stops (nothing to reveal). */
export const formatDispatchStopsTooltip = (row: DispatchStopsSource): string | undefined => {
  const locations = dispatchStopLocations(row);
  if (locations.length < 2) return undefined;
  return locations.map((location, index) => `${index + 1}. ${location}`).join('\n');
};
